import { render, staticRenderFns } from "./UdefUserCardHorizontal.vue?vue&type=template&id=5f83a69e&scoped=true&"
import script from "./UdefUserCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./UdefUserCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./UdefUserCardHorizontal.vue?vue&type=style&index=0&id=5f83a69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83a69e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
